import React from 'react';
import ArgSVG from '../assets/images/countriesFlags/bundle.esm2.js';
import BolSVG from '../assets/images/countriesFlags/bundle.esm.js';
import BraSVG from '../assets/images/countriesFlags/bundle.esm5.js';
import ChlSVG from '../assets/images/countriesFlags/bundle.esm3.js';
import ColSVG from '../assets/images/countriesFlags/bundle.esm4.js';
import EcuSVG from '../assets/images/countriesFlags/bundle.esm7.js';
import PrySVG from '../assets/images/countriesFlags/bundle.esm6.js';
import PerSVG from '../assets/images/countriesFlags/bundle.esm8.js';
import UrySVG from '../assets/images/countriesFlags/bundle.esm11.js';
import VenSVG from '../assets/images/countriesFlags/bundle.esm9.js';
import USASVG from '../assets/images/countriesFlags/bundle.esm10.js';

const getFlagIcon = () => {
  const countries = [
    {
      countryCode: "AR",
      icon: /* @__PURE__ */ React.createElement(ArgSVG, {
        className: "Flag"
      })
    },
    {
      countryCode: "BO",
      icon: /* @__PURE__ */ React.createElement(BolSVG, {
        className: "Flag"
      })
    },
    {
      countryCode: "BR",
      icon: /* @__PURE__ */ React.createElement(BraSVG, {
        className: "Flag"
      })
    },
    {
      countryCode: "CL",
      icon: /* @__PURE__ */ React.createElement(ChlSVG, {
        className: "Flag"
      })
    },
    {
      countryCode: "CO",
      icon: /* @__PURE__ */ React.createElement(ColSVG, {
        className: "Flag"
      })
    },
    {
      countryCode: "EC",
      icon: /* @__PURE__ */ React.createElement(EcuSVG, {
        className: "Flag"
      })
    },
    {
      countryCode: "PY",
      icon: /* @__PURE__ */ React.createElement(PrySVG, {
        className: "Flag"
      })
    },
    {
      countryCode: "PE",
      icon: /* @__PURE__ */ React.createElement(PerSVG, {
        className: "Flag"
      })
    },
    {
      countryCode: "UY",
      icon: /* @__PURE__ */ React.createElement(UrySVG, {
        className: "Flag"
      })
    },
    {
      countryCode: "VE",
      icon: /* @__PURE__ */ React.createElement(VenSVG, {
        className: "Flag"
      })
    },
    {
      countryCode: "US",
      icon: /* @__PURE__ */ React.createElement(USASVG, {
        className: "Flag"
      })
    }
  ];
  return countries;
};
const findFlagIconByCountryCode = (countryCode) => {
  if (!countryCode) {
    console.warn("PhoneNumberInputUI: No country code was provided");
    return null;
  }
  const country = getFlagIcon().find((item) => item.countryCode === countryCode);
  if (!country) {
    console.warn(
      "PhoneNumberInputUI: No country flag found based on country code provided"
    );
    return null;
  }
  return country.icon;
};

export { findFlagIconByCountryCode, getFlagIcon };
//# sourceMappingURL=bundle.esm6.js.map
